import PropTypes from 'prop-types';
import { DetailedIconEmail, Spacer } from '@zillow/constellation';
import { Button, Heading, Modal, Paragraph } from '@zillow/constellation-10';

const MultifamilyDeactivationModal = ({ setShowMultifamilyDeactivateModal }) => (
  <Modal
    open={true}
    onOpenChange={(open) => !open && setShowMultifamilyDeactivateModal(false)}
    header={<Heading level={2}>Zillow support required</Heading>}
    footer={
      <Button onClick={() => setShowMultifamilyDeactivateModal(false)} tone="brand" emphasis="filled">
        OK
      </Button>
    }
    size={{ base: 'fullScreen', md: 'md' }}
    body={
      <div data-testid="MultifamilyDeactivationModal">
        <Spacer marginBottom="md">
          <DetailedIconEmail />
        </Spacer>
        <Heading level="4" marginBottom="sm" fontFamily="serif">
          Contact a Zillow representative
        </Heading>
        <Paragraph>
          Your contract with Zillow requires that a Zillow representative assist you in deactivating this listing.
          Please contact us for help with this task.
        </Paragraph>
      </div>
    }
  />
);

MultifamilyDeactivationModal.propTypes = { setShowMultifamilyDeactivateModal: PropTypes.func };

MultifamilyDeactivationModal.defaultProps = { setShowMultifamilyDeactivateModal: () => {} };

export default MultifamilyDeactivationModal;
